// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file storage/storage.proto (package vsmr.storage.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CopyFileRequest, CopyFileResponse, DeleteFilesRequest, DeleteFilesResponse, DownloadFileRequest, DownloadFileResponse, DownloadTaskResultFileRequest, ListFilesRequest, ListFilesResponse, ListResultFilesRequest, ListResultFilesResponse, UploadFileRequest, UploadFileResponse } from "./storage_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service vsmr.storage.v1.StorageService
 */
export const StorageService = {
  typeName: "vsmr.storage.v1.StorageService",
  methods: {
    /**
     * Copy an object to another object key (run inputs: the build cache's FMU, the origin run's rstplt)
     *
     * @generated from rpc vsmr.storage.v1.StorageService.CopyFile
     */
    copyFile: {
      name: "CopyFile",
      I: CopyFileRequest,
      O: CopyFileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Retrieve the list of result files for a specific task
     *
     * @generated from rpc vsmr.storage.v1.StorageService.ListResultFiles
     */
    listResultFiles: {
      name: "ListResultFiles",
      I: ListResultFilesRequest,
      O: ListResultFilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Download a file from object storage as a stream
     *
     * @generated from rpc vsmr.storage.v1.StorageService.DownloadFile
     */
    downloadFile: {
      name: "DownloadFile",
      I: DownloadFileRequest,
      O: DownloadFileResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Download a task result file by project/task/file identifiers as a stream
     *
     * @generated from rpc vsmr.storage.v1.StorageService.DownloadTaskResultFile
     */
    downloadTaskResultFile: {
      name: "DownloadTaskResultFile",
      I: DownloadTaskResultFileRequest,
      O: DownloadFileResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * Key primitives — the caller names the object key; it must lie in the caller's own space
     * ({user_id}/…, no empty/'.'/'..' segments — the BFF object reference scope checks it). The layout
     * of what goes where (run folders, build cache) is the client's single declaration, not the server's.
     * Upload content to an object key.
     *
     * @generated from rpc vsmr.storage.v1.StorageService.UploadFile
     */
    uploadFile: {
      name: "UploadFile",
      I: UploadFileRequest,
      O: UploadFileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * List the objects under "{object_prefix}/" — every object, or only the immediate children.
     *
     * @generated from rpc vsmr.storage.v1.StorageService.ListFiles
     */
    listFiles: {
      name: "ListFiles",
      I: ListFilesRequest,
      O: ListFilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Delete objects by key (a missing key is not an error — deleting is idempotent).
     *
     * @generated from rpc vsmr.storage.v1.StorageService.DeleteFiles
     */
    deleteFiles: {
      name: "DeleteFiles",
      I: DeleteFilesRequest,
      O: DeleteFilesResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

